<div class="accordion-item">
    <h3 class="accordion-header" id="headingOne">
        <button class="accordion-button" (click)="showAddress = !showAddress" [ngClass]="{'collapsed':!showAddress}" type="button" data-bs-toggle="collapse" data-bs-target="#INSAddress1" aria-expanded="true" aria-controls="INSAddress1">
      <span>Address</span>
      <div class="arrow"></div>
    </button>
    </h3>
    <div id="INSAddress1" class="accordion-collapse collapse" aria-labelledby="INSAddress1"
    [ngClass]="{'show':showAddress}" [formGroup]="addressForm">
        <div class="accordion-body">

            <div class="row">

                <div class="col-3 mb-3">
                    <label for="currencySel4" class="form-label">Country<span class="mandatory">*</span></label>
                    <div [ngClass]="{'is-invalid' : submitted && addressForm?.controls?.['country']?.errors?.['required']}">
                        <app-single-select uid="countryId" [searchShow]=true [dataArr]="countryList"
                            (selectedEvent)="selectedValue($event,'country');" label="countryName"
                            [selectedData]="addressForm.value.country" [placeholder]="'Select'">
                        </app-single-select>
                    </div>
                    <span *ngIf="submitted && addressForm?.controls?.['country']?.errors?.['required']"
                        class="invalid-feedback d-block" tabindex="0">This field is required</span>
                </div>
                <div class="col-3 mb-3">
                    <label for="currencySel4" class="form-label">State/Region<span class="mandatory">*</span></label>
                    <div [ngClass]="{'is-invalid' : submitted && addressForm?.controls?.['country']?.errors?.['required']}">
                        <app-single-select uid="regionId" [dataArr]="stateList" [searchShow]=true
                            (selectedEvent)="selectedValue($event,'state');" label="regionName"
                            [selectedData]="addressForm.value.state" [placeholder]="'Select'">
                        </app-single-select>
                    </div>
                    <span *ngIf="submitted && addressForm?.controls?.['state']?.errors?.['required']"
                    class="invalid-feedback d-block" tabindex="0">This field is required</span>
                </div>
                <div class="col-3 mb-3">
                    <label for="INSarea1" class="form-label">Area<span class="mandatory">*</span></label>
                    <div [ngClass]="{'is-invalid' : submitted && addressForm?.controls?.['area']?.errors?.['required']}">
                    <app-single-select uid="id" [dataArr]="dummydata1"
                    (selectedEvent)="selectedValue($event,'area');" label="name"
                    [selectedData]="addressForm.value.area" [placeholder]="'Select'">
                </app-single-select>
                </div>
                <span *ngIf="submitted && addressForm?.controls?.['area']?.errors?.['required']"
                    class="invalid-feedback d-block" tabindex="0">This field is required</span>
                </div>
                <div class="col-3 mb-3">
                    <label for="insAreaCode1" class="form-label">Area code</label>
                    <input autocomplete="disabled" type="text" id="insAreaCode1" formControlName="areaCode" class="form-control "
                    [ngClass]="{'is-invalid' :submitted && addressForm?.controls?.['areaCode']?.errors?.['required']}" appPreventFirstSpace>
                    <span *ngIf="submitted && addressForm?.controls?.['areaCode']?.errors?.['required']"
                    class="invalid-feedback d-block" tabindex="0">This field is required</span>
                </div>
                <div class="col-3 mb-3">
                    <label for="INSGeocode1" class="form-label">Geo code</label>
                    <div [ngClass]="{'is-invalid' : submitted && addressForm?.controls?.['geoCode']?.errors?.['required']}" >
                    <app-single-select uid="id" [dataArr]="dummydata1"
                    (selectedEvent)="selectedValue($event,'geoCode');" label="name"
                    [selectedData]="addressForm.value.geoCode" [placeholder]="'Select'">
                </app-single-select>
                </div>
                <span *ngIf="submitted && addressForm?.controls?.['geoCode']?.errors?.['required']"
                    class="invalid-feedback d-block" tabindex="0">This field is required</span>
                </div>
                <div class="col-3 mb-3">
                    <label for="insBuilingName1" class="form-label">Building Name</label>
                    <input autocomplete="disabled" type="text" id="insBuilingName1" formControlName="buildingName" 
                    class="form-control" [ngClass]="{'is-invalid' : submitted && addressForm?.controls?.['buildingName']?.errors?.['required']}" appPreventFirstSpace>
                
                    <span *ngIf="submitted && addressForm?.controls?.['buildingName']?.errors?.['required']"
                    class="invalid-feedback d-block" tabindex="0">This field is required</span></div>

                <div class="col-3 mb-3">
                    <label for="insStreetName1" class="form-label">Street Name</label>
                    <input autocomplete="disabled" type="text" id="insStreetName1" formControlName="streetName" class="form-control"
                    [ngClass]="{'is-invalid' : submitted && addressForm?.controls?.['streetName']?.errors?.['required']}" appPreventFirstSpace>
                
                    <span *ngIf="submitted && addressForm?.controls?.['streetName']?.errors?.['required']"
                    class="invalid-feedback d-block" tabindex="0">This field is required</span>
                </div>

            </div>
        </div>
    </div>
</div>
